import React, { CSSProperties } from 'react';
import { BpDesignSystem } from '../../types';
import { DropdownProps, Dropdown } from '../Dropdown';
import { IconButton, IconButtonProps } from '../IconButton/IconButton';

export interface IconDropdownProps
  extends BpDesignSystem.PropsWithChildren<Omit<DropdownProps, 'ButtonItem' | 'fullWidth'>> {
  iconName?: IconButtonProps['iconName'];
  iconSize?: IconButtonProps['size'];
  iconClassName?: string;
  iconStyle?: CSSProperties;
  disabledMessage?: string;
}

export const IconDropdown: React.FC<IconDropdownProps> = ({
  iconName = 'more_vert',
  iconClassName,
  iconStyle,
  iconSize,
  disabledMessage,
  dataTest,
  ...rest
}) => (
  <Dropdown
    dataTest={dataTest}
    ButtonItem={({ disabled }) => (
      <IconButton
        disabledToolTipText={disabledMessage}
        iconName={iconName}
        aria-label={rest.tooltip ?? 'icon'}
        dataTest={dataTest ? `${dataTest}-button` : 'icon-dropdown-button'}
        disabled={disabled}
        className={iconClassName}
        size={iconSize}
        style={{ ...iconStyle, ...(disabled ? { pointerEvents: 'none' } : undefined) }}
      />
    )}
    {...rest}
  />
);
